import { IApplicationState } from '../../types/redux';
import { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';
import { getIsAnswerAuthorAnonymousById } from '../answers/getIsAnswerAuthorAnonymousById';
import { getIsQuestionAuthorAnonymousById } from '../questions/getIsQuestionAuthorAnonymousById';
import { getIsReviewAuthorAnonymousById } from '../reviews/getIsReviewAuthorAnonymousById';

export const getIsAuthorAnonymousById =
  (openId: TSetNewAnswerFormOpenPayload | null) =>
  (state: IApplicationState): boolean => {
    if (!openId) {
      return false;
    }

    const { id, type } = openId;

    switch (type) {
      case 'review':
        return getIsReviewAuthorAnonymousById(id)(state);
      case 'question':
        return getIsQuestionAuthorAnonymousById(id)(state);
      case 'answer':
        return getIsAnswerAuthorAnonymousById(id)(state);
      default:
        return false;
    }
  };
